<div
  class="d-flex"
  data-cy="file-upload-drop-zone"
  appFileUploadDrop
  [multiple]="multiple()"
  [accept]="accept()"
  [sizeLimit]="sizeLimit()"
  [imageSizeLimit]="imageSizeLimit()"
  [files]="files"
  (filesDrop)="filesChanged($event)">
  <app-files-list [files]="files" (deleteFile)="onDeleteFile($event)" />

  <app-file-upload-button
    [multiple]="multiple()"
    [accept]="accept()"
    [sizeLimit]="sizeLimit()"
    [imageSizeLimit]="imageSizeLimit()"
    [hidden]="!canUploadMoreFiles"
    (filesChange)="filesChanged($event)" />
</div>
